module.exports = __webpack_public_path__ + "img/man-torso-front.562060c4.png";